export type DeployVersionPayload = {
  version?: string;
  builtAt?: string;
  displayVersion?: string;
};

export function getDeployVersionLabel(payload: DeployVersionPayload | null): string | null {
  if (!payload) return null;

  if (typeof payload.displayVersion === 'string' && payload.displayVersion.trim()) {
    return payload.displayVersion.trim();
  }

  if (typeof payload.version !== 'string' || !payload.version.trim()) return null;

  const timestampMatch = payload.version.match(/^(\d{4})-(\d{2})-(\d{2})_/);
  if (timestampMatch) {
    return `${Number(timestampMatch[2])}-${Number(timestampMatch[3])}`;
  }

  return payload.version.trim();
}
